module.exports = __webpack_public_path__ + "static/media/feature_shiftManagement.825edaa9.png";